<template>
  <report-section title="数据摘要" style="position: relative">
    <template v-slot:content>
      <div class="data-abstract">
        <data-abstract-unit :title="ahiTitle" :value="model.ahi" :isHighLight="true"></data-abstract-unit>

        <data-abstract-unit v-if="deviceType === 0" title="最高呼吸率" :value="model.maxBreathRate"></data-abstract-unit>
        <!-- <data-abstract-unit v-if="model.reportTemplateType === 34" title="最低血氧饱和度" :value="model.minBloodOxygenSaturation+' %'"></data-abstract-unit>
    <data-abstract-unit v-if="model.isShowAverageBreathRate" title="平均呼吸率"
      :value="model.averageBreathRate"></data-abstract-unit> -->
        <data-abstract-unit v-if="deviceType === 0" title="最低呼吸率" :value="model.minBreathRate"></data-abstract-unit>

        <!-- 氧气减指数进度条 -->
        <div class="ahi-bar-right">
          <div class="ahi-bar-right-triangle" :style="triangleStyleObject" v-if="showAhiBarTriangle"></div>
          <div class="ahi-bar-right-top">
            <div :style="greenBarStyleObject"></div>
            <div :style="yellowBarStyleObject"></div>
            <div :style="orangeBarStyleObject"></div>
            <div :style="redBarStyleObject"></div>
          </div>
          <div class="ahi-bar-right-bottom">
            <p class="ahi-bar-right-bottom-number">0</p>
            <p class="ahi-bar-right-bottom-text">正常</p>
            <p class="ahi-bar-right-bottom-number">{{ model.ahiDegreeArray[0] }}</p>
            <p class="ahi-bar-right-bottom-text">轻度</p>
            <p class="ahi-bar-right-bottom-number">{{ model.ahiDegreeArray[1] }}</p>
            <p class="ahi-bar-right-bottom-text">中度</p>
            <p class="ahi-bar-right-bottom-number">{{ model.ahiDegreeArray[2] }}</p>
            <p class="ahi-bar-right-bottom-text">重度</p>
            <p class="ahi-bar-right-bottom-number">∞</p>
          </div>
        </div>
      </div>
    </template>

  </report-section>
</template>


<script>
import DataAbstractUnit from "./data-abstract-unit.vue";
import ReportSection from "@c/report-detail/single-blood-oxygen-report/common/report-section.vue";
export default {
  components: {
    DataAbstractUnit,
    ReportSection,
  },

  props: {
    model: Object,

  },

  data() {
    return {
      degreeStyleArray: [
        { width: 23.5, color: "#16d585" },
        { width: 23.5, color: "#EDF200" },
        { width: 24, color: "#F28300" },
        { width: 28, color: "#F2001D" },
      ],
    };
  },

  computed: {
    ahiTitle() {
      return `${this.model.ahiTitle}指数`
    },

    showAhiBarTriangle() {
      const ahiValue = parseFloat(this.model.ahi);
      return !isNaN(ahiValue) && ahiValue >= 0;
    },

    greenBarStyleObject() {
      return {
        width: `${this.degreeStyleArray[0].width}%`,
        backgroundColor: this.degreeStyleArray[0].color,
      };
    },

    yellowBarStyleObject() {
      return {
        width: `${this.degreeStyleArray[1].width}%`,
        backgroundColor: this.degreeStyleArray[1].color,
      };
    },

    orangeBarStyleObject() {
      return {
        width: `${this.degreeStyleArray[2].width}%`,
        backgroundColor: this.degreeStyleArray[2].color,
      };
    },

    redBarStyleObject() {
      return {
        width: `${this.degreeStyleArray[3].width}%`,
        backgroundColor: this.degreeStyleArray[3].color,
      };
    },
    deviceType() {
      return this.model.deviceType
    },

    triangleStyleObject() {
      if (this.model.ahi === "") {
        return {
          visibility: "hidden",
        };
      } else {
        for (let index = 0; index < this.model.ahiDegreeArray.length; index++) {
          const item = this.model.ahiDegreeArray[index];
          var value = Number.parseFloat(this.model.ahi);
          if (value > 100) {
            value = 100
          }
          if (value <= item) {
            let width = 0;
            for (let i = 0; i < index; i++) {
              width += this.degreeStyleArray[i].width;
            }
            const formerItem = index == 0 ? 0 : this.model.ahiDegreeArray[index - 1];
            const valueDifference = value - formerItem;
            const itemDifference = item - formerItem;
            const widthRate = valueDifference / itemDifference;
            width += this.degreeStyleArray[index].width * widthRate;
            return {
              marginLeft: `${width - 1.5}%`,
              borderTopColor: this.degreeStyleArray[index].color,
            };
          }
          continue;
        }
      }
    },
  },
  mounted() {
    // console.log('this.deviceType',this.deviceType,this.model)
  }
};
</script>

<style lang="scss" scoped>
.data-abstract {
  width: 100%;
  box-sizing: border-box;
  padding: rem(10) rem(20);
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.ahi-bar-right {
  width: 40%;
  height: rem(30);

  &-triangle {
    display: inline-block;
    width: 0;
    height: 0;
    border-top: rem(12) solid;
    border-left: rem(6) solid transparent;
    border-right: rem(6) solid transparent;
  }

  &-top {
    display: flex;
    width: 100%;
    height: rem(10);

    div {
      height: 100%;
    }
  }

  &-bottom {
    color: #333333;
    font-size: rem(14);
    width: 96%;
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-top: rem(10);

    &-number {
      color: #999999;
      font-size: rem(12);
      height: rem(25);
    }

    &-text {
      color: #333333;
      font-size: rem(14);
    }
  }
}
</style>